import { TabPath } from "@/constants/Navigation";
import GroupClassDetailsModal from "@/ui/components/groupClasses/GroupClassDetailsModal";

// GroupClassDetailsModal is used on both the Home Tab and the Explore Tab.
// However, the product expectation is that deep links to <app>/group-class-details open on the Explore tab.
// Thus, this component is re-used in (explore)/group-class-details, as well as (home)/explore-groups-details,
// (And for app/(app)/(modals)/group-class-list-details to use for the tab-independent group-class-list)/
// This preserves the deep link at <app>/group-class-details and also reuses the exact same component.

// dismissToPath is the Explore tab so closing this deep-linkable modal returns there.
const ExploreGroupClassDetailsModal = () => (
  <GroupClassDetailsModal dismissToPath={TabPath.Explore} />
);

export default ExploreGroupClassDetailsModal;
